<script>
import SearchResultsTab from '@phoenix/mixins/components/search/SearchResultsTab';
import LoadMoreButton from '@maison/components/search/LoadMoreButton';
import { PhxsgButton } from '@sg/src/View/Components/Atoms/Button';

export default {
  components: {
    LoadMoreButton,
    PhxsgButton,
  },

  mixins: [SearchResultsTab],

  props: {
    hasPagingLabel: {
      type: Boolean,
      default: false,
    },
    sectionClasses: {
      type: String,
      default: 'section section--sm theme--light',
    },
  },

  computed: {
    displayActions() {
      return this.hasLimit || this.displayLoadMore || !!this.$slots.actions;
    },
    tabName() {
      return this.$t(`Search.tab.${this.tab}`);
    },
  },

  mounted() {
    if (this.displayLoadMore) {
      this.loadMoreObserver = new IntersectionObserver(this.onElementObserved, {
        rootMargin: '0px 0px 600px 0px',
      });
      if (this.$refs.observerTarget) {
        this.loadMoreObserver.observe(this.$refs.observerTarget);
      }
    }
  },

  beforeUnmount() {
    if (this.loadMoreObserver) {
      this.loadMoreObserver.disconnect();
    }
  },

  methods: {
    onElementObserved(entries) {
      if (!this.isLoading && entries.find((entry) => entry.isIntersecting)) {
        this.loadData({ clearData: false, tab: this.tab });
      }
    },
    hasNoResultAction() {
      return !!this.$slots.noResultAction;
    },
  },
};
</script>

<template>
  <div v-if="isGlobalLoading" class="search-panel-loader">
    <div class="loader loader--dark">
      <div class="loader__inner"></div>
    </div>
  </div>
  <section v-else-if="hasResults" :class="sectionClasses">
    <slot />

    <p v-if="hasPagingLabel" class="filtered-search-results__results-count">
      {{ $t('search.query.tab.paging', { count: displayedResultsCount, total: results, name: tabName }) }}
    </p>

    <div v-if="displayLoadMore && isLoading" class="box box--center mt-lg">
      <div class="loader loader--dark">
        <div class="loader__inner"></div>
      </div>
    </div>

    <ul v-if="displayActions" ref="observerTarget" class="actions actions--centered mt-lg">
      <li role="presentation">
        <PhxsgButton v-if="hasLimit" variant="plain" color="secondary" @click="onViewAllClick">
          {{ $t('Search.button.seeAllResults') }}
        </PhxsgButton>
      </li>

      <li role="presentation">
        <load-more-button v-if="displayLoadMore && !isLoading" @click="onLoadMoreClick" />
      </li>

      <slot name="actions" />
    </ul>
  </section>
  <div v-else class="search-no-result">
    <p class="search-no-result__text">{{ $t(`Search.tab.${tab}.noResult`) }}</p>

    <ul v-if="hasNoResultAction" class="actions actions--centered" role="presentation">
      <li role="presentation">
        <slot name="noResultAction" />
      </li>
    </ul>
  </div>
</template>
